const BRANCH_NAME = 'main';
export const BLOG_ROOT_URL = `https://raw.githubusercontent.com/hallsamuel90/brik-blog-content/${BRANCH_NAME}`;

export const BLOG_STORE_URL = `${BLOG_ROOT_URL}/blog-posts-store.json`;
export const BLOG_CONTENT_URL = `${BLOG_ROOT_URL}/blog-posts`;
